
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/meta",
      function () {
        return require("private-next-pages/landing/meta.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/meta"])
      });
    }
  